var diffuser_builder_el = document.getElementById('diffuser-builder');
var diffuser_addon_products = JSON.parse(diffuser_builder_el.dataset.addonProducts || '[]');
// One-time-purchase-only volume discount — must mirror the equivalent Shopify discount
// (scoped to "One-time purchases") that actually enforces this at checkout; see content-diffuser-builder.liquid.
// This is a plain template data attribute (human-entered dollars), unlike the variant/selling-plan
// prices below which come straight from Shopify Liquid and are already in cents.
var diffuser_volume_discount_cents = Math.round(parseFloat(diffuser_builder_el.dataset.volumeDiscountAmount || '0') * 100);
var diffuser_volume_discount_min_quantity = parseInt(diffuser_builder_el.dataset.volumeDiscountMinQuantity || '0', 10);

var vue_diffuser = new Vue({
	el: diffuser_builder_el,
	delimiters: ['[[',']]'],
	data: function(){
		// default-select the first scent + its first frequency, same starting state the old
		// Loop Bundle fetch used to seed once it loaded — no fetch needed now, so no async wait
		var first_product = diffuser_all_products[0];
		var first_variant_id = first_product && first_product.variants[0] && first_product.variants[0].id;
		var first_plan_options = first_variant_id ? (diffuser_selling_plan_allocations[first_variant_id] || []) : [];

		if ( !first_variant_id ) {
			console.error('No diffuser-oils products found');
		}

		return {
			scent_options: diffuser_all_products, // every diffuser-oils product, straight from Shopify — no Loop Bundle involved
			selected_variant_ids: first_variant_id ? [first_variant_id] : [],
			selected_selling_plan_id: null,
			addon_products: diffuser_addon_products // non-subscription add-ons, from #diffuser-builder data attribute
		};
	},
	computed: {
		// Every frequency offered on whichever selected variant has selling plans — all
		// diffuser-oils products currently share the same Loop selling plan, so any selected
		// variant's options represent the whole set.
		selling_plan_options: function(){
			for ( var i = 0 ; i < this.selected_variant_ids.length ; i++ ) {
				var options = diffuser_selling_plan_allocations[this.selected_variant_ids[i]];
				if ( options && options.length ) { return options; }
			}
			return [];
		},

		// Fragrance-only pricing (excludes add-ons) — this is what the "Choose scents" section
		// header shows: the running total for the selected scents, and the pre-discount
		// subtotal to strike through when a discount applies. Subscription pricing comes
		// straight from Shopify's own selling_plan_allocations (already net of whatever the
		// selling plan discounts), so there's no discount value to duplicate/keep in sync here
		// — the one-time volume discount is the only discount this file still calculates itself.
		fragrance_totals: function(){
			var scope = this;
			var subtotal_cents = 0;
			var total_cents = 0;
			this.selected_variant_ids.forEach(function(variantId){
				var product = scope.scent_options.find(function(p){ return p.variants[0].id == variantId; });
				if ( !product ) { return; }
				var unit_cents = product.variants[0].price;
				subtotal_cents += unit_cents;

				var line_cents = unit_cents;
				if ( scope.selected_selling_plan_id ) {
					var allocations = diffuser_selling_plan_allocations[variantId] || [];
					var allocation = allocations.find(function(a){ return a.id == scope.selected_selling_plan_id; });
					if ( allocation ) { line_cents = allocation.price; }
				} else if ( scope.selected_variant_ids.length >= diffuser_volume_discount_min_quantity ) {
					line_cents = Math.max(unit_cents - diffuser_volume_discount_cents, 0);
				}
				total_cents += line_cents;
			});
			return {
				subtotal_cents: subtotal_cents,
				total_cents: total_cents,
				discount_applied: total_cents < subtotal_cents
			};
		},

		cart_total_cents: function(){
			var addon_cents = 0;
			this.addon_products.forEach(function(p){ addon_cents += (p.price_cents || 0) * p.quantity; });
			return this.fragrance_totals.total_cents + addon_cents;
		}
	},
	methods: {
		format_money: function(amt){
			return slate.Currency.formatMoney(amt).replace('.00', '');
		},

		fragrance_notes: function(option){
			return diffuser_all_products_data[option.id].fragrance_notes;
		},

		option_title: function(option){
			return option.title.replace(option.type,'');
		},

		build_cart: function(){
			var scope = this;
			var items = [];
			this.selected_variant_ids.forEach(function(variantId){
				items.push({
					'id': variantId,
					'quantity': 1,
					'selling_plan': scope.selected_selling_plan_id
				});
			});
			// non-subscription add-ons — plain line items, no selling_plan
			this.addon_products.forEach(function(p){
				items.push({
					'id': p.id,
					'quantity': p.quantity
				});
			});
			var json_cart_field = $('#json_cart_field');
			json_cart_field.val(JSON.stringify(items));
			json_cart_field.trigger('change');
		}
	}
});
